module.exports = __webpack_public_path__ + "img/beauty_survey.34fbb34e.png";